import styled from "styled-components";

export const BodyInfo = styled.div`
    width: 100%;
    min-height: 20px;
    height: auto;  
    box-sizing: border-box;
    padding: 15px;
`;

export const TitleInfo = styled.div`
    width: 100%;
    height: 25px;
    padding: 14px 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 1.4em;
    font-weight: normal;
    font-family: Arial, Helvetica, sans-serif;
    margin-bottom: 10px;
    border-bottom: 1px solid gray;
`;

export const OtherInfo = styled.div`
    font-size: 1.0em;
    padding-left: 15px;
    margin-bottom: 5px;
`;

export const TextConfirm = styled.div`
    font-size: 1.3em;
    text-align: center;
    font-family: Arial, Helvetica, sans-serif;
    padding-top: 20px;
    margin-bottom: 20px;
`;